module.exports = __webpack_public_path__ + "img/Mstory02.a0003a66.png";